import { __extends } from "tslib";
import { getLightElement } from '@tyler-components-web/core';
import { BADGE_CONSTANTS } from '../../badge';
import { BaseAdapter } from '../../core/adapters/base-adapter';
var OmnibarNotificationButtonAdapter = /** @class */ (function (_super) {
    __extends(OmnibarNotificationButtonAdapter, _super);
    function OmnibarNotificationButtonAdapter(component) {
        return _super.call(this, component) || this;
    }
    OmnibarNotificationButtonAdapter.prototype.initialize = function () {
        this._badgeElement = getLightElement(this._component, BADGE_CONSTANTS.elementName);
    };
    OmnibarNotificationButtonAdapter.prototype.setCount = function (value) {
        this._badgeElement.textContent = value;
    };
    OmnibarNotificationButtonAdapter.prototype.setBadgeType = function (dot) {
        this._badgeElement.dot = dot;
    };
    OmnibarNotificationButtonAdapter.prototype.setBadgeTheme = function (theme) {
        if (theme) {
            this._badgeElement.setAttribute(BADGE_CONSTANTS.attributes.THEME, theme);
        }
        else {
            this._badgeElement.removeAttribute(BADGE_CONSTANTS.attributes.THEME);
        }
    };
    OmnibarNotificationButtonAdapter.prototype.setBadgeVisible = function (isVisible) {
        this._badgeElement.open = isVisible;
    };
    return OmnibarNotificationButtonAdapter;
}(BaseAdapter));
export { OmnibarNotificationButtonAdapter };
